// ✅ Common reusable duration comparison method

export const isDurationLessThanMilestones = (duration, durationType, milestoneList) => {
  // Convert to total days based on type
  const convertToDays = (value, type) => {
    const val = parseInt(value) || 0;
    switch (parseInt(type)) {
      case 2:
        return val; // Days
      case 3:
        return val * 7; // Weeks
      case 4:
        return val * 30; // Months (approx)
      default:
        return 0;
    }
  };

  const totalProjectDays = convertToDays(duration, durationType);
  const totalMilestoneDays = (milestoneList || []).reduce((sum, m) => {
    return sum + convertToDays(m?.duration, m?.duration_type);
  }, 0);

  // ✅ Return true if milestones total duration <= project duration
  return totalMilestoneDays <= totalProjectDays;
};
